import React from 'react';
import cx from 'classnames';
import TextProps, { Sizing } from './Text.types';
import styles from './Text.module.scss';
import { TextColor } from '../../shared/types/textColor.types';

const Text = ({
  children,
  bold = false,
  italic = false,
  underline = false,
  sizing = Sizing.Regular,
  className,
  color = TextColor.Primary,
  dataCy = 'text',
}: TextProps) => (
  <div
    data-cy={dataCy}
    className={cx(styles.textComponent, styles[sizing], styles[color], className, {
      [styles.bold]: bold,
      [styles.italic]: italic,
      [styles.underline]: underline,
    })}>
    {children}
  </div>
);

export default Text;
